module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--file-4b4c3a34665d16a6f2c1f7d844c159ed.png";